"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _formatting = require("../helpers/formatting");
var ExtrasFlightPicker = function ExtrasFlightPicker(_ref) {
  var direction = _ref.direction,
    variants = _ref.variants,
    selectedVariant = _ref.selectedVariant,
    airports = _ref.airports,
    selectedAirport = _ref.selectedAirport,
    flights = _ref.flights,
    selectedFlight = _ref.selectedFlight,
    updateVariant = _ref.updateVariant,
    updateAirport = _ref.updateAirport,
    updateFlight = _ref.updateFlight,
    disabled = _ref.disabled,
    destinationAirports = _ref.destinationAirports;
  var airportObject = destinationAirports.find(function (destAirport) {
    if (selectedAirport) {
      return destAirport.airport.name === selectedAirport.label;
    }
    return null;
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, "".concat((0, _formatting.capitalizeFirstLetter)(direction), " transfer:"), /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
    searchable: false,
    clearable: false,
    value: selectedVariant,
    options: variants,
    onChange: function onChange(variant) {
      return updateVariant(variant, direction);
    },
    disabled: disabled
  })), /*#__PURE__*/_react["default"].createElement("div", null, "Airport:", /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
    searchable: false,
    clearable: false,
    value: selectedAirport,
    options: airports,
    onChange: function onChange(airport) {
      updateAirport(airport, direction);
    },
    disabled: disabled
  })), selectedAirport && /*#__PURE__*/_react["default"].createElement("div", null, "Transfer departure time", /*#__PURE__*/_react["default"].createElement(_reactSelect["default"], {
    searchable: false,
    clearable: false,
    value: selectedFlight,
    options: flights,
    onChange: function onChange(flight) {
      return updateFlight(flight, direction);
    },
    disabled: disabled
  })), airportObject && airportObject.airport && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      maxWidth: '100%'
    }
  }, airportObject.airport.transferInfo));
};
ExtrasFlightPicker.propTypes = {
  direction: _propTypes["default"].string.isRequired,
  variants: _propTypes["default"].array.isRequired,
  selectedVariant: _propTypes["default"].object,
  airports: _propTypes["default"].array.isRequired,
  selectedAirport: _propTypes["default"].object,
  flights: _propTypes["default"].array,
  selectedFlight: _propTypes["default"].object,
  updateVariant: _propTypes["default"].func.isRequired,
  updateAirport: _propTypes["default"].func.isRequired,
  updateFlight: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  destinationAirports: _propTypes["default"].array
};
var _default = exports["default"] = ExtrasFlightPicker;